import tw from 'tailwind-styled-components'

export const CareUserListContainer = tw.div`
    flex
    gap-8
    p-4
`
